import { useTranslation } from "react-i18next";
import CriticalAlertsSection from "./critical-alerts/CriticalAlertsSection";
import ConsentSection from "./consent/ConsentSection";
import RemindersSection from "./reminders/RemindersSection";
import SoorAlertsSection from "./soor-alerts/SoorAlertsSection";
import { WorklistProvider } from "./WorklistContext";

/**
 * "TODAY'S WORKLIST" — the frame that wraps every worklist section (KAN-2553).
 *
 * Maria: the heading encapsulates all the sections; each one carries its own
 * sub-header. A new section renders as a sibling here and adds its id to
 * WORKLIST_SECTION_IDS in worklist.service.ts, in the same order, so the
 * running row numbering picks it up.
 */
const Worklist = () => {
	const { t } = useTranslation("common");

	return (
		<WorklistProvider>
			<div className="worklist">
				<h2 className="worklist__title">{t("HOME.WORKLIST.TITLE")}</h2>
				<CriticalAlertsSection />
				<SoorAlertsSection />
				<ConsentSection />
				<RemindersSection />
			</div>
		</WorklistProvider>
	);
};

export default Worklist;
